'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import GradeTypeConstants from '../../constants/GradeTypeConstants';
import classNames from 'classnames';

var IconResultSection = /*#__PURE__*/function (_Component) {
  _inherits(IconResultSection, _Component);

  function IconResultSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, IconResultSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(IconResultSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getTickOrXIconClasses = function () {
      var gradeType = _this.props.gradeType;
      return classNames("icon", gradeType === GradeTypeConstants.GOOD && 'icon-check-circle', gradeType === GradeTypeConstants.BAD && 'icon-delete-circle');
    };

    return _this;
  }

  _createClass(IconResultSection, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_jsxs("div", {
        className: "flip-card-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "left",
          children: /*#__PURE__*/_jsx("div", {
            className: this.getTickOrXIconClasses()
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "info",
          children: [/*#__PURE__*/_jsx(ResultHeader, Object.assign({}, props)), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, props))]
        })]
      });
    }
  }]);

  return IconResultSection;
}(Component);

IconResultSection.propTypes = {
  gradeType: PropTypes.string,
  resultHeader: PropTypes.string,
  resultIcon: PropTypes.string
};
export { IconResultSection as default };